import AbstractConfig from "../../../core/config/AbstractConfig";

export default class SoundConfig extends AbstractConfig {
    constructor() {
        super();
    }

    getVolume(id) {
        return this.getValue('volume.' + id);
    }

    getSoundId(imageId) {
        let soundId = this.getValue('soundPerLocation.' + imageId);
        console.log("Playing audio: "+ soundId+ " with volume: "+ this.getVolume(soundId));
        return soundId;
    }
}